import React from 'react';
import { Form } from 'react-bootstrap';
import './Checkbox.scss';

export interface CheckboxProps {
    label?: string | React.ReactNode
    name: string
    value?: string | number
    defaultChecked?: boolean
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
    required?: boolean
    disabled?: boolean
    type?: 'checkbox' | 'radio'
    style?: React.CSSProperties
    className?: string
    checked?: boolean
    id?: string
    error?: string
}

const Checkbox: React.FC<CheckboxProps> = ({
    label,
    name,
    value = '1',
    defaultChecked,
    onChange,
    required = false,
    disabled = false,
    type = 'checkbox',
    style,
    className = '',
    checked = false,
    id,
}) => {
    const checkClass = `st-${type}`;

    return (
        <Form.Group controlId={id || `${name}-${value}`}>
            <Form.Check
                key={`${name}-${value}`}
                id={id || `${name}-${value}`}
                type={type}
                label={label}
                name={name}
                value={value}
                checked={checked || defaultChecked}
                onChange={onChange}
                className={`${checkClass} ${className} h-xs-100` }
                required={required}
                disabled={disabled}
                style={{ ...style, opacity: disabled ? 0.5 : 1 }}
            />
        </Form.Group>
    );
};

export default Checkbox;
